<template>
  <router-view />
</template>

<style lang="scss">
  @import "./src/scss/style--light";
</style>
